import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { noop } from 'lodash';

import iconMenu from 'images/icon-menu.svg';
import { ReactComponent as IconEdit } from 'images/icon-edit.svg';
import iconDelete from 'images/icon-delete-red.svg';
import iconUpload from 'images/upload.svg';

export type DotsDropdownProps = {
  onEdit?: any;
  onDelete?: any;
  onUploadNewReport?: () => void;
};

type DropdownItemProps = {
  onClick: any;
  disabled?: boolean;
};

export default function DotsDropdown({
  onEdit,
  onDelete,
  onUploadNewReport,
}: DotsDropdownProps) {
  const { t } = useTranslation(['common', 'plan']);

  const dropdownItemProps = (onClickFn: any | undefined): DropdownItemProps => {
    return {
      onClick: onClickFn || noop,
      disabled: !onClickFn,
    };
  };

  const editItemProps = dropdownItemProps(onEdit);
  const deleteItemProps = dropdownItemProps(onDelete);

  return (
    <div className="Character-menu" data-testid="DotsDropdown">
      <Dropdown
        onToggle={(_, e) => {
          if (
            e?.originalEvent?.stopPropagation &&
            typeof e.originalEvent.stopPropagation === 'function'
          )
            e.originalEvent.stopPropagation();
        }}
        className="dropdown--settings"
      >
        <Dropdown.Toggle
          variant="success"
          id="dropdown-settings"
          className="u-pointer t-outline-none"
          data-testid="DotsDropdown-toggle"
        >
          <img src={iconMenu} alt={t('common:alt_dropdown_menu')} />
        </Dropdown.Toggle>

        <Dropdown.Menu className="t-m-0">
          <Dropdown.Item {...editItemProps}>
            <IconEdit className="dropdown-icon t-text-beta-200" />
            {t('common:edit_label')}
          </Dropdown.Item>

          <Dropdown.Item {...deleteItemProps}>
            <img
              src={iconDelete}
              alt=""
              role="presentation"
              className="dropdown-icon dropdown-icon--delete"
            />
            {t('common:delete_label')}
          </Dropdown.Item>

          {onUploadNewReport && (
            <>
              <Dropdown.Item onClick={onUploadNewReport}>
                <img
                  src={iconUpload}
                  className="dropdown-icon button-icon-amazon"
                  alt=""
                  role="presentation"
                />
                {t('common:upload_new_report_label')}
              </Dropdown.Item>
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
